import { getSidebarCustomize } from ".";
function calculateControlBreadcrumb(setting) {
    return new Promise((resolve)=>{
        const customize = getSidebarCustomize();
        customize.control(setting, (param)=>{
            let { container, section } = param;
            const foundHeadlines = {};
            container.prevAll(".customize-control-headline").each(function() {
                const h = jQuery(this).children().children().get(0);
                const { nodeName, innerHTML } = h;
                if (!foundHeadlines[nodeName]) {
                    foundHeadlines[nodeName] = innerHTML;
                }
            });
            resolve([
                customize.section(section()).headContainer.text().trim().split("\n")[0],
                ...Object.values(foundHeadlines).reverse(),
                container.find(".customize-control-title,input+label").first().text()
            ].join(" ▸ "));
        });
    });
}
export { calculateControlBreadcrumb };
